import React from 'react'
import HospitalDepartment from '../../components/HospitalDepartment/HospitalDepartment'

const HospitalDepartmentPage = () => {
  return (
     <HospitalDepartment/>
  )
}

export default HospitalDepartmentPage